<div class="card height-100 custom-color p-shadow-9">
    <h5 class="centerText">Број скидања апликације по години</h5>
    <p-chart [data]="yearlyChartData" [options]="pieChartOptions" type="pie" height="400px"></p-chart>
</div>
